(function () {
  'use strict';

  var COOKIE_NAME = 'ouidad_quiz_recs';
  var COOKIE_DAYS = 30;

  function flattenRecommendationIds(recommendations) {
    var ids = [];
    if (!recommendations || typeof recommendations !== 'object') return ids;
    Object.keys(recommendations).forEach(function (key) {
      var value = recommendations[key];
      var items = Array.isArray(value) ? value : [value];
      items.forEach(function (item) {
        if (item && item.productId != null) {
          ids.push(String(item.productId));
        }
      });
    });
    return ids.filter(function (id, i) { return ids.indexOf(id) === i; });
  }

  function parseRecsCookie(cookieString, cookieName) {
    var name = (cookieName || COOKIE_NAME) + '=';
    var parts = String(cookieString || '').split('; ');
    var raw = null;
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(name) === 0) {
        raw = parts[i].substring(name.length);
        break;
      }
    }
    if (!raw) return [];
    try {
      var parsed = JSON.parse(decodeURIComponent(raw));
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function writeRecommendations(recommendations) {
    var ids = flattenRecommendationIds(recommendations);
    setCookie(COOKIE_NAME, JSON.stringify(ids), COOKIE_DAYS);
    return ids;
  }

  function getRecommendedIds() {
    return parseRecsCookie(document.cookie, COOKIE_NAME);
  }

  function tagCards(scopeEl, idSet, badgeText) {
    if (!idSet || !idSet.size) return;
    var scope = scopeEl || document;
    if (!scope.querySelectorAll) return;
    var cards = scope.querySelectorAll(
      'product-card-atc[data-product-id]:not([data-rec-badged])'
    );
    cards.forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (!idSet.has(id)) return;
      var container = card.querySelector('.product-badges');
      if (!container) return;
      var el = document.createElement('div');
      el.className = 'badge recommended-for-you';
      el.textContent = badgeText;
      container.appendChild(el);
      card.setAttribute('data-rec-badged', 'true');
    });
  }

  function init() {
    var script = document.currentScript ||
      document.querySelector('script[data-quiz-rec-badge]');
    var badgeText = (script && script.getAttribute('data-badge-text')) ||
      'Recommended For You';

    var idSet = new Set(getRecommendedIds());

    var run = function () { tagCards(document, idSet, badgeText); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    if (idSet.size && 'MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            var node = added[n];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('product-card-atc')) {
              tagCards(node.parentNode || node, idSet, badgeText);
            } else if (node.querySelector && node.querySelector('product-card-atc')) {
              tagCards(node, idSet, badgeText);
            }
          }
        }
      });
      var start = function () {
        observer.observe(document.body, { childList: true, subtree: true });
      };
      if (document.body) start();
      else document.addEventListener('DOMContentLoaded', start);
    }
  }

  window.QuizRecBadge = {
    writeRecommendations: writeRecommendations,
    getRecommendedIds: getRecommendedIds
  };
  init();
})();
